module.exports = "pegasus_template/assets/tech/sale/100.png";